<ul class="list-group">
	<li class="list-group-item"><a id="myBids_manage_alerts" href="{{contextPath}}/itemalerts">{{{JspPublicCodes_JSP_MY_BIDS_MANAGE_ALERTS}}}</a></li>
	{{#if showAllItemAlerts}}
		<li class="list-group-item {{active}}"><a id="myBids_alerts_all" class="x-alert-filter" href="#">{{{JspPublicCodes_JSP_MY_BIDS_VIEW_ALL_ALERT_MATCHES}}}</a></li>
	{{/if}}
	{{#alerts}}
		<li class="list-group-item {{active}}"><a id="myBids_alerts_{{id}}" class="x-alert-filter" data-alert="{{id}}" href="#">{{{name}}}</a></li>
	{{/alerts}}
</ul>
